<template>
    <div class="columns wrapper">
      <div class="column is-one-quarter area-navigation">
        <ul class="navigation">
          <li v-for="(item, index) in menuItems" :key="item.title" v-if="item.adminOnly? isCompanyAdmin : true">
            <a @click.prevent="selectItem(index)"
               :class="{'router-link-active': index === activeIndex, 'is-invisible': !item.isAvailable }"
               href="#">{{ item.title }}</a>
          </li>
        </ul>
      </div>
      <div class="column area-content">
        <keep-alive>
          <component :is="activeComponent"></component>
        </keep-alive>
      </div>
    </div>
</template>

<script>
import AccountInfo from './BasicAccountInfo'
import { mapGetters } from 'vuex'
export default {
  name: 'Account-Carrier',

  data() {
    return {
      menuItems: [
        { title: 'Basic Account Info', component: AccountInfo, isAvailable: true, adminOnly: false },
        { title: 'Insurance & TIP', component: AccountInfo, isAvailable: false },
        { title: 'Equipment', component: AccountInfo, isAvailable: false },
        { title: 'Activity', component: AccountInfo, isAvailable: false },
        { title: 'Help & Support', component: AccountInfo, isAvailable: false }
      ],
      activeIndex: 0
    }
  },

  computed: {
    ...mapGetters('user', ['isCompanyAdmin']),

    activeComponent() {
      return this.menuItems[this.activeIndex].component
    }
  },

  methods: {
    selectItem(index) {
      if (this.menuItems[index].isAvailable) {
        this.activeIndex = index
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  min-height: 400px;
  margin: 8px 0;
  padding: 5px;
}

.navigation {
  display: flex;
  flex-direction: column;
  li {
    margin: 8px 0;
  }
}

.router-link-active {
  font-weight: bolder;
  color: black;
}

.area-content {
  border-left: 1px solid blue;
}
</style>
